import React from 'react'
import { useLocation,useNavigate } from 'react-router-dom'
import { showDate } from "../../constant"

const ViewUser = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let data = location?.state;
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className="xl:flex xl:items-center xl:justify-between">
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              User Details
            </h1>
            <button type="button" className="btn btn-light" onClick={()=>navigate('/dashboard/user/')}>
              Back
            </button>
          </div>

          <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                    <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  </svg>
                  <span className="text-gray-600">
                    User Id
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Created - <span>{showDate(data.created_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Updated - <span>{showDate(data.updated_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Deleted - <span>{showDate(data.deleted_at)}</span>
                  </span>
                </div>
              </div>
              <div className="mt-2 space-y-6">
                <div className="overflow-hidden bg-white rounded-lg shadow">
                  <div className="px-4 py-5 sm:p-6">
                    <div className="grid xl:grid-cols-6 gap-y-10">
                      <div className="xl:col-span-6 xl:pr-8 order-1 lg:order-1 md:order-2 sm:order-2 xs:order-2">
                        <div className="space-y-6">
                          <div>
                            <div className="flex items-center">
                              <p className="font-medium">
                                User Details
                              </p>
                            </div>
      
                            <div className="mt-3 space-y-3">
                              <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                                <div className="px-4 py-5 sm:p-6">
                                  <div className="grid grid-cols-4 gap-5 md:grid-cols-6">
                                    <div className="col-span-3 md:col-span-3 md:order-1">
                                      <p className="text-sm text-gray-600">
                                        Name
                                      </p>
                                      <p className="mt-1 text-lg leading-tight text-primary-600">
                                       {data.firstname + " " + data.lastname}
                                      </p>
                                    </div>
                                  </div>
      
                                  <div className="grid grid-cols-2 gap-5 mt-5 sm:grid-cols-3 xl:grid-cols-6">
                                    <div className='col-span-2 md:col-span-1 sm:col-span-2 lg:col-span-1'>
                                      <p className="text-sm text-gray-600">
                                        Email
                                      </p>
                                      <p className="mt-1">
                                        {data.email}
                                      </p>
                                    </div>

                                    <div className='col-span-2 md:col-span-1 sm:col-span-2 lg:col-span-1'>
                                      <p className="text-sm text-gray-600">
                                        Contact
                                      </p>
                                      <p className="mt-1">
                                        {data.mobile}
                                      </p>
                                    </div>

                                    <div>
                                      <p className="text-sm text-gray-600">
                                        Role
                                      </p>
                                      <div className="mt-1">
                                        {data.userRole.type}
                                      </div>
                                    </div>

                                    <div>
                                      <p className="text-sm text-gray-600">
                                        Gender
                                      </p>
                                      <div className="mt-1">
                                        {data.gender}
                                      </div>
                                    </div>

                                    <div>
                                      <p className="text-sm text-gray-600">
                                        Username
                                      </p>
                                      <div className="mt-1">
                                        {data.username}
                                      </div>
                                    </div>

                                    <div>
                                      <p className="text-sm text-gray-600">
                                        Status
                                      </p>
                                      <p className="mt-1 py-3">
                                        {
                                          data.is_active? 
                                          (<span className='px-4 py-3 bg-green-500 rounded-md text-white text-center'>Active</span>) 
                                          : 
                                          (<span className='px-2 py-3 bg-red-500 rounded-md text-white text-center'>Deactive</span>)
                                        }
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div> 
    </div>
  )
}

export default ViewUser
